/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import ReceiptTypeEnum from './ReceiptTypeEnum';





/**
* The ReceiptDTO model module.
* @module model/ReceiptDTO
* @version 0.7.15
*/
export default class ReceiptDTO {
    /**
    * Constructs a new <code>ReceiptDTO</code>.
    * @alias module:model/ReceiptDTO
    * @class
    * @param version {Number} The version of the receipt.
    * @param type {module:model/ReceiptTypeEnum} 
    */

    constructor(version, type) {
        

        
        

        this['version'] = version;this['type'] = type;

        
    }

    /**
    * Constructs a <code>ReceiptDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ReceiptDTO} obj Optional instance to populate.
    * @return {module:model/ReceiptDTO} The populated <code>ReceiptDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ReceiptDTO();

            
            
            

            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'Number');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ReceiptTypeEnum.constructFromObject(data['type']);
            }
        }
        return obj;
    }

    /**
    * The version of the receipt.
    * @member {Number} version
    */
    version = undefined;
    /**
    * @member {module:model/ReceiptTypeEnum} type
    */
    type = undefined;








}


